<template>
  <div class="security">
    <el-container>
      <el-header style="height: 100px">

        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="hero-section">
          <div class="hero-content">
            <h1 class="hero-title">
              <span class="gradient-text">安全合规</span>
              <span class="normal-text">是我们的承诺</span>
            </h1>
            <div class="hero-description">
              奇迹IP始终坚守安全合规原则，致力于提供安全、稳定、优质的大数据代理服务，保障用户合法权益，推动全球大数据业务的健康有序发展
            </div>
            <div class="security-stats">
              <div class="stat-item">
                <div class="stat-number">100<span class="stat-symbol">%</span></div>
                <div class="stat-label">合规运营</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">24<span class="stat-symbol">h</span></div>
                <div class="stat-label">安全监控</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">0</div>
                <div class="stat-label">安全事故</div>
              </div>
            </div>
          </div>
        </div>

        <div class="security-section">
          <div class="section-header">
            <h2 class="section-title">安全合规管理</h2>
            <div class="section-subtitle">遵守国家法律法规，实施行业领先的安全管控措施</div>
          </div>
          <div class="security-cards">
            <div class="security-card" v-for="(item, index) in securityFeatures" :key="index">
              <div class="card-icon">
                <i :class="item.icon"></i>
              </div>
              <h3 class="card-title">{{ item.title }}</h3>
              <p class="card-description">{{ item.description }}</p>
              <div class="card-features">
                <div class="feature-item" v-for="(feature, fIndex) in item.features" :key="fIndex">
                  <i class="el-icon-check"></i>
                  <span>{{ feature }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="standards-section">
          <div class="section-header">
            <h2 class="section-title">安全标准认证</h2>
            <div class="section-subtitle">符合国际顶级安全标准，为您的数据安全保驾护航</div>
          </div>
          <div class="standards-grid">
            <div class="standard-card">
              <div class="standard-icon">
                <img src="http://apiupss.ppfly.top/images/stand_icon2.svg" alt="ISO认证">
              </div>
              <div class="standard-content">
                <div class="standard-badge">
                  <img src="http://apiupss.ppfly.top/images/authentication.svg" alt="认证标志">
                </div>
                <h3 class="standard-title">ISO 27001</h3>
                <p class="standard-description">信息安全管理体系认证</p>
                <ul class="standard-features">
                  <li>数据安全管理</li>
                  <li>风险评估与控制</li>
                  <li>安全策略制定</li>
                  <li>持续监控与改进</li>
                </ul>
              </div>
            </div>
            <div class="standard-card">
              <div class="standard-icon">
                <img src="http://apiupss.ppfly.top/images/stand_icon1.svg" alt="ISO认证">
              </div>
              <div class="standard-content">
                <div class="standard-badge">
                  <img src="http://apiupss.ppfly.top/images/authentication.svg" alt="认证标志">
                </div>
                <h3 class="standard-title">ISO 9001</h3>
                <p class="standard-description">质量管理体系认证</p>
                <ul class="standard-features">
                  <li>服务质量保证</li>
                  <li>流程标准化</li>
                  <li>持续优化</li>
                  <li>客户满意度管理</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="feedback-section">
          <div class="section-header">
            <h2 class="section-title">安全情报反馈</h2>
            <div class="section-subtitle">共同维护网络安全，打造健康的数据服务生态</div>
          </div>
          <div class="feedback-container">
            <div class="feedback-content">
              <div class="feedback-description">
                <p>若您发现与奇迹IP相关的安全合规情报，请及时与我们取得联系。我们将：</p>
                <ul class="feedback-list">
                  <li><i class="el-icon-check"></i>第一时间响应您的反馈</li>
                  <li><i class="el-icon-check"></i>专业团队迅速核实</li>
                  <li><i class="el-icon-check"></i>采取有效措施处理</li>
                  <li><i class="el-icon-check"></i>及时向您反馈结果</li>
                </ul>
                <div class="feedback-warning">
                  <h4>重点关注问题：</h4>
                  <ul>
                    <li>非法网站访问行为</li>
                    <li>可疑的欺诈活动</li>
                    <li>未授权的攻击行为</li>
                    <li>侵犯权益的违规内容</li>
                    <li>其他违法违规行为</li>
                  </ul>
                </div>
              </div>
              <div class="contact-info">
                <h3>联系我们</h3>
                <div class="contact-methods">
                  <div class="contact-details">
                    <p>全天候安全响应</p>
                    <div class="contact-item">
                      <i class="el-icon-phone"></i>
                      <span>电话：{{ this.$tel }}</span>
                    </div>
                    <div class="contact-item">
                      <i class="el-icon-message"></i>
                      <span>邮箱：{{ this.$email }}</span>
                    </div>
                  </div>
                  <div class="qr-code">
                    <img src="@/assets/weixin.jpg" alt="二维码">
                    <p>扫码关注奇迹ip</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>

<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";

export default {
  name: 'SecurityPage',
  components: {
    Head,
    Footer,
    Xuanfuret
  },
  data() {
    return {
      securityFeatures: [
        {
          icon: 'el-icon-user',
          title: '实名认证',
          description: '严格的身份验证确保服务安全可控',
          features: [
            '企业资质认证',
            '法人身份验证',
            '多重身份校验',
            '实时认证状态'
          ]
        },
        {
          icon: 'el-icon-lock',
          title: '账户安全',
          description: '多重防护确保账户和资产安全',
          features: [
            'IP白名单控制',
            '多因素认证',
            '异常行为监控',
            '实时风险预警'
          ]
        },
        {
          icon: 'el-icon-warning',
          title: '风险管控',
          description: '全方位风险监控和管理系统',
          features: [
            '实时行为分析',
            '智能风控系统',
            '合规性审查',
            '安全事件响应'
          ]
        }
      ]
    }
  },

  mounted() {

  },
  methods: {},
}

</script>
<style scoped>
.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0;
}

.el-header {
  position: sticky;
  top: 0;
  background-color: #edf3fc;
  z-index: 5;
}


.security {
  position: relative;
}

.heads_top {
  position: absolute;
}

.H_sec {
  font-size: 54px;
  color: #1b2336;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
}

.security_main_body {
  padding: 0;
  overflow-x: hidden;
}

.hero-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.hero-content {
  flex: 1;
  max-width: 600px;
}

.hero-title {
  font-size: 48px;
  line-height: 1.2;
  margin-bottom: 24px;
}

.gradient-text {
  background: linear-gradient(90deg, #6327d3, #8b4fff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.normal-text {
  color: #1b2336;
}

.hero-description {
  font-size: 18px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 40px;
}

.security-stats {
  display: flex;
  gap: 40px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  color: #6327d3;
  line-height: 1;
  margin-bottom: 8px;
}

.stat-symbol {
  font-size: 24px;
  margin-left: 4px;
}

.stat-label {
  font-size: 16px;
  color: #666;
}

.hero-image {
  flex: 1;
  max-width: 500px;
  margin-left: 40px;
}

.floating-animation {
  width: 100%;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-20px);
  }

  100% {
    transform: translateY(0px);
  }
}

.security-section {
  max-width: 1200px;
  margin: 100px auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 36px;
  color: #1b2336;
  margin-bottom: 16px;
}

.section-subtitle {
  font-size: 18px;
  color: #666;
}

.security-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.security-card {
  background: #fff;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.security-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(99, 39, 211, 0.15);
}

.card-icon {
  width: 60px;
  height: 60px;
  background: rgba(99, 39, 211, 0.1);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.card-icon i {
  font-size: 30px;
  color: #6327d3;
}

.card-title {
  font-size: 24px;
  color: #1b2336;
  margin-bottom: 16px;
}

.card-description {
  font-size: 16px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.6;
}

.card-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.feature-item i {
  color: #6327d3;
  font-size: 16px;
}

.feature-item span {
  font-size: 14px;
  color: #333;
}

@media (max-width: 1200px) {
  .hero-section {
    flex-direction: column;
    text-align: center;
  }

  .hero-content {
    max-width: 100%;
    margin-bottom: 40px;
  }

  .security-stats {
    justify-content: center;
  }

  .hero-image {
    max-width: 80%;
    margin: 0 auto;
  }

  .security-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 36px;
  }

  .security-stats {
    flex-direction: column;
    gap: 20px;
  }

  .security-cards {
    grid-template-columns: 1fr;
  }
}

.security_main_body_div_B {
  margin-top: 100px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.security_main_body_div_B_H {
  font-size: 36px;
  color: #1b2336;
  text-align: center;
  margin-bottom: 16px;
}

.text_sec_B {
  font-size: 18px;
  color: #666;
  text-align: center;
  margin-bottom: 60px;
}

.standards-section {
  max-width: 1200px;
  margin: 100px auto;
  padding: 0 20px;
}

.standards-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  margin-top: 60px;
}

.standard-card {
  background: #fff;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 30px;
  transition: all 0.3s ease;
}

.standard-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(99, 39, 211, 0.15);
}

.standard-icon {
  flex-shrink: 0;
}

.standard-icon img {
  width: 60px;
  height: 60px;
}

.standard-content {
  flex: 1;
}

.standard-badge {
  margin-bottom: 20px;
}

.standard-badge img {
  height: 28px;
}

.standard-title {
  font-size: 28px;
  color: #1b2336;
  margin-bottom: 10px;
}

.standard-description {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.standard-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.standard-features li {
  position: relative;
  padding-left: 24px;
  margin-bottom: 12px;
  color: #333;
  font-size: 14px;
}

.standard-features li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6327d3;
}

.feedback-section {
  max-width: 1200px;
  margin: 100px auto;
  padding: 0 20px;
}

.feedback-container {
  background: linear-gradient(135deg, #f8f9ff 0%, #f2f6ff 100%);
  border-radius: 30px;
  padding: 60px;
  margin-top: 60px;
}

.feedback-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 60px;
}

.feedback-description {
  color: #333;
}

.feedback-description p {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 30px;
}

.feedback-list {
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
}

.feedback-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  font-size: 16px;
}

.feedback-list li i {
  color: #6327d3;
}

.feedback-warning {
  background: rgba(99, 39, 211, 0.05);
  border-radius: 15px;
  padding: 24px;
}

.feedback-warning h4 {
  color: #1b2336;
  margin: 0 0 16px 0;
  font-size: 18px;
}

.feedback-warning ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feedback-warning li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 12px;
  color: #666;
  font-size: 14px;
}

.feedback-warning li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #6327d3;
}

.contact-info {
  background: #fff;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.contact-info h3 {
  font-size: 24px;
  color: #1b2336;
  margin: 0 0 24px 0;
}

.contact-methods {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.contact-details p {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.contact-item i {
  color: #6327d3;
  font-size: 20px;
}

.contact-item span {
  color: #333;
  font-size: 16px;
}

.qr-code {
  text-align: center;
  align-items: center;
  justify-content: center;
}

.qr-code img {
  width: auto;
  height: auto;
  border-radius: 10px;
  margin-bottom: 12px;
}

.qr-code p {
  font-size: 14px;
  color: #666;
}

@media (max-width: 1200px) {
  .standards-grid {
    grid-template-columns: 1fr;
  }

  .feedback-content {
    grid-template-columns: 1fr;
  }

  .feedback-container {
    padding: 40px;
  }
}

@media (max-width: 768px) {
  .standard-card {
    flex-direction: column;
    padding: 30px;
  }

  .feedback-container {
    padding: 30px;
  }

  .contact-methods {
    flex-direction: column;
  }

  .qr-code {
    margin-top: 30px;
  }
}
</style>
